import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { LegalTerms } from '~/components/AgreementStudioPage/AgreementStudioModal/LegalTerms/LegalTerms';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export const legalTermErrorsTextsPath = 'proposal.studio.legalTerms.errors';
const getLegalTermErrors = (legalTerms, texts)=>{
    return legalTerms.map((legalTerm)=>{
        var _legalTerm_termsOfService;
        const errors = {};
        if (legalTerm === null) {
            errors.legalTermField = texts.pleaseChooseDocument();
        }
        if ((legalTerm === null || legalTerm === void 0 ? void 0 : (_legalTerm_termsOfService = legalTerm.termsOfService) === null || _legalTerm_termsOfService === void 0 ? void 0 : _legalTerm_termsOfService.type) === 'explicitApproval') {
            var _legalTerm_termsOfService_explicitApproval_statement, _legalTerm_termsOfService_explicitApproval_statement1;
            if (!((_legalTerm_termsOfService_explicitApproval_statement = legalTerm.termsOfService.explicitApproval.statement) === null || _legalTerm_termsOfService_explicitApproval_statement === void 0 ? void 0 : _legalTerm_termsOfService_explicitApproval_statement.trim())) {
                errors.explicitApproval = texts.pleaseEnterCheckboxStatement();
            } else if (((_legalTerm_termsOfService_explicitApproval_statement1 = legalTerm.termsOfService.explicitApproval.statement) === null || _legalTerm_termsOfService_explicitApproval_statement1 === void 0 ? void 0 : _legalTerm_termsOfService_explicitApproval_statement1.length) > 120) {
                errors.explicitApproval = texts.statementMaxLength();
            }
        }
        return errors;
    });
};
const hasLegalTermsErrors = (legalTerms, texts)=>{
    return legalTerms.length === 0 || getLegalTermErrors(legalTerms, texts).some((error)=>error.legalTermField || error.explicitApproval);
};
function TermsOfServiceModalContent(param) {
    let { draft, setDraft, wasSubmitted } = param;
    const { t: errorTexts } = useLocaleKeys(legalTermErrorsTextsPath);
    const legalTermsDocuments = draft.legalTermsDocuments();
    const errors = useMemo(()=>wasSubmitted ? getLegalTermErrors(legalTermsDocuments, errorTexts) : [], [
        wasSubmitted,
        legalTermsDocuments
    ]);
    const onAgreementLegalTermsChange = (updatedLegalTerms)=>{
        setDraft(draft.setLegalTermsDocuments(updatedLegalTerms));
    };
    return /*#__PURE__*/ _jsx(LegalTerms, {
        withTitle: false,
        withExplicitApproval: true,
        withSignatureApproval: false,
        agreementLegalTerms: legalTermsDocuments,
        onAgreementLegalTermsChange: onAgreementLegalTermsChange,
        errors: errors,
        editContext: "proposal",
        sourceId: draft.id()
    });
}
export default function TermsOfServiceCell(param) {
    let { isDisabled, disabledTooltip, draft, index, onOpenModal } = param;
    const { t: draftCellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells.draft');
    const { t: errorTexts } = useLocaleKeys(legalTermErrorsTextsPath);
    const agreementLegalTermsDocuments = draft.legalTermsDocuments();
    const onClick = ()=>onOpenModal({
            submitOnNotDirty: true,
            shouldSubmit: async (editedDraft)=>{
                return !hasLegalTermsErrors(editedDraft.legalTermsDocuments(), errorTexts);
            },
            width: '700px',
            maxHeight: '600px',
            renderContent: (param)=>{
                let { draft, setDraft, wasSubmitted } = param;
                return {
                    title: draftCellsTexts.termsOfService(),
                    testId: 'edit-terms-modal',
                    content: /*#__PURE__*/ _jsx(TermsOfServiceModalContent, {
                        draft: draft,
                        setDraft: setDraft,
                        wasSubmitted: wasSubmitted
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    const getLegalTermsName = ()=>{
        var _ref;
        var _agreementLegalTermsDocuments_;
        if (agreementLegalTermsDocuments.length > 1) {
            return draftCellsTexts.documentsCount({
                count: agreementLegalTermsDocuments.length
            });
        }
        return (_ref = agreementLegalTermsDocuments === null || agreementLegalTermsDocuments === void 0 ? void 0 : (_agreementLegalTermsDocuments_ = agreementLegalTermsDocuments[0]) === null || _agreementLegalTermsDocuments_ === void 0 ? void 0 : _agreementLegalTermsDocuments_.displayName) !== null && _ref !== void 0 ? _ref : '';
    };
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-terms-of-service-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "terms-of-service-".concat(index),
            children: getLegalTermsName()
        })
    });
}
